/**
 * Recently Played Games Store
 */

define(function(require, exports, module) {
    'use strict';

    var AbstractStore = require('stores/abstract.store');
    var RecentlyPlayedCollection = require('stores/recently-played-games/recently-played-games.collection');

    var RecentlyPlayedGamesStore = AbstractStore.extend({
        type: 'RecentlyPlayedGames',
        /**
         * Collection with recently played games models
         * @type {RecentlyPlayedCollection}
         */
        _collection: new RecentlyPlayedCollection(),
    });

    module.exports = RecentlyPlayedGamesStore;
});